import React from 'react';

const Best = () => {
    return (
        <div className='best'>
           <h2>Best 페이지</h2> 
        </div>
    );
};

export default Best;